import React, {Component} from "react"
import PropTypes from "prop-types"
import {Link} from 'react-router-dom'
import {Badge, Button, ButtonToolbar, Col, Glyphicon, Panel, Row} from "react-bootstrap"
import {Acl, Enums, Grid} from "../../utils"

class UserDetail extends Component {

	constructor(props) {
		super(props);

		this.state = {
			sendingEmail: false
		};
	}

	componentWillMount() {
		// this.props.onFetchEnums(["countries", "clubs", "role"])
	}

	componentWillReceiveProps(nextProps) {
		// if (nextProps.item && (!this.props.item || nextProps.item.userId !== this.props.item.userId)) {
		// 	if (nextProps.item.entityUsers && nextProps.item.entityUsers.length > 0) {
		// 		for (let i in nextProps.item.entityUsers) {
		// 			if (nextProps.item.entityUsers.hasOwnProperty(i)) {
		// 				const su = nextProps.item.entityUsers[i];
		// 				this.props.onFetchEnums(["categories", "sportTypes", "universities"], su.entity.entityId)
		// 			}
		// 		}
		// 	}
		// }
	}

	getStatusTitle(value) {
		switch (value) {
			case "ACTIVE":
				return <span><Glyphicon glyph="ok" /> Aktivní</span>;
			case "DELETED":
				return <span><Glyphicon glyph="remove" /> Smazaný</span>;
			default:
				return value
		}
	}

	render() {
		const {isFetchingItem, item, enums} = this.props;

		if (isFetchingItem || item === null) {
			return Grid.renderIsFetchingData()
		}

		return <div className={"detail"}>
			<Row key={1}>
				<Col lg={6} lgOffset={3}>
					<Panel>
						<Panel.Heading>
							<span>Uživatel <Badge className="pull-right">{item.userId}</Badge></span>
						</Panel.Heading>
						<Panel.Body>
							<table className="table table-detail">
								<colgroup>
									<col width="15%"/>
									<col width="30%"/>
									<col width="15%"/>
									<col width="15%"/>
									<col width="25%"/>
								</colgroup>
								<tbody>
								<tr>
									<th>Jméno</th>
									<td>{item.firstName}</td>
								</tr>
								<tr>
									<th>Příjmení</th>
									<td>{item.lastName}</td>
								</tr>
								<tr>
									<th>Email</th>
									<td>{item.email}</td>
								</tr>
								<tr className="divider">
									<th>Oprávnění</th>
									<td>{(item.roleId ? Enums.getEnumTitle(enums, 'role', item.roleId) : '(není)')}</td>
								</tr>
								<tr className="divider">
									<th>Stav</th>
									<td>{this.getStatusTitle(item.status)}</td>
								</tr>
								</tbody>
							</table>
						</Panel.Body>
					</Panel>
				</Col>
			</Row>
			<Row>
				<Col sm={12} className="text-center">
					<ButtonToolbar>
						{Acl.hasAction(item, Acl.user.EDIT) && item.email !== null && item.roleId > 0 && item.status === 'ACTIVE' ?
						<Button bsStyle="link" disabled={this.state.sendingEmail} onClick={() =>
							this.props.onShowModal(
								'Odeslat přístupové údaje',
								'Skutečně odeslat instrukce k nastavení hesla na adresu ' + item.email + '?',
								{style: 'success', label: 'Odeslat instrukce', icon: 'envelope'},
								() => {
									this.setState({sendingEmail: true});
									return this.props.onForgottenPassword(item.email, false).then((json) => {
										this.setState({sendingEmail: false});
										if (json && json.response && json.response.result === 'OK') {
											//
										} else {
											return new Promise((resolve, reject) => reject())
										}
									})
								}
							)
						}><Glyphicon glyph={this.state.sendingEmail ? "refresh" : "envelope"} className={this.state.sendingEmail ? "spin" : ""}/> Odeslat přístupové údaje</Button> : null}
						{Acl.hasAction(item, Acl.user.EDIT) &&
						<Link to={{pathname: "/uzivatele/" + item.userId + "/uprava"}} className="btn btn-success"><Glyphicon glyph="pencil"/> Upravit uživatele</Link>}
					</ButtonToolbar>
				</Col>
			</Row>
		</div>
	}
}

UserDetail.propTypes = {
	item: PropTypes.object,
	isFetchingItem: PropTypes.bool.isRequired,
	onFetchEnums: PropTypes.func.isRequired,
	onForgottenPassword: PropTypes.func.isRequired,
	onShowModal: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
};

export default UserDetail



// WEBPACK FOOTER //
// ./src/components/user/UserDetail.js